var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { Translate } from "../I18N";

export default class Modal extends Component {
  render() {
    const style = {
      overlay: { zIndex: this.props.zIndex, backgroundColor: 'rgba(0, 0, 0, 0.75)' }
    };
    const { type, className, children, isOpen } = this.props;
    return (/*#__PURE__*/
      _jsx(ReactModal, {
        style: style,
        className: `modal-dialog modal-${type} ${className}`,
        isOpen: isOpen,
        contentLabel: "",
        ariaHideApp: false }, void 0, /*#__PURE__*/

      _jsx("div", { className: "modal-content", "data-testid": "modal" }, void 0,
      children
      )
      ));

  }
}










Modal.defaultProps = {
  isOpen: false,
  type: 'success',
  className: '',
  zIndex: 100
};
const Body = ({ children }) => /*#__PURE__*/_jsx("div", { className: "modal-body" }, void 0, children);


const Header = ({ children }) => /*#__PURE__*/_jsx("div", { className: "modal-header" }, void 0, children);


const Footer = ({ children }) => /*#__PURE__*/_jsx("div", { className: "modal-footer" }, void 0, children);


const Title = ({ children }) => /*#__PURE__*/_jsx("h4", { className: "modal-title" }, void 0, children);


const Close = ({ onClick }) => /*#__PURE__*/
_jsx("button", { type: "button", className: "close", onClick: onClick }, void 0, /*#__PURE__*/
_jsx("span", { "aria-hidden": "true" }, void 0, "\xD7"), /*#__PURE__*/
_jsx("span", { className: "sr-only" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Close")
)
);



Modal.Body = Body;
Modal.Header = Header;
Modal.Footer = Footer;
Modal.Title = Title;
Modal.Close = Close;